import Header from "../components/Header";
import Footer from "../components/Footer";

export default function PrivacyPolicy() {
    return (
        <>
            <Header />
            <section className="pt-36 pb-24 bg-gradient-to-b from-white to-slate-50">
                <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
                    <h1 className="text-3xl sm:text-4xl font-bold text-slate-800 mb-2">Privacy Policy</h1>
                    <p className="text-slate-500 text-sm mb-8">Last updated: June 29, 2026</p>

                    <div className="space-y-8 text-slate-600">

                        <div>
                            <h2 className="text-xl font-semibold text-slate-800 mb-3">1. Introduction</h2>
                            <p>Welcome to Adeya IMS. We respect your privacy and are committed to protecting your personal data. This privacy policy explains how we collect, use, and safeguard your information when you use our inventory management system.</p>
                        </div>

                        <div>
                            <h2 className="text-xl font-semibold text-slate-800 mb-3">2. Information We Collect</h2>
                            <p className="mb-2">We may collect the following types of information:</p>
                            <ul className="list-disc pl-6 space-y-1">
                                <li><strong>Business Information:</strong> Company name, business address, GST number, and industry type</li>
                                <li><strong>Contact Information:</strong> Name, email address, phone number, and designation</li>
                                <li><strong>Account Credentials:</strong> Username and encrypted password</li>
                                <li><strong>Transactional Data:</strong> Purchase orders, sales invoices, inventory levels, vendor details, and customer information</li>
                                <li><strong>Usage Data:</strong> How you interact with our platform, features used, and time spent</li>
                            </ul>
                        </div>

                        <div>
                            <h2 className="text-xl font-semibold text-slate-800 mb-3">3. How We Use Your Information</h2>
                            <p className="mb-2">We use your information to:</p>
                            <ul className="list-disc pl-6 space-y-1">
                                <li>Provide, operate, and maintain our inventory management system</li>
                                <li>Process transactions and manage your account</li>
                                <li>Generate reports, analytics, and insights for your business</li>
                                <li>Communicate with you about updates, security alerts, and support</li>
                                <li>Improve and optimize our platform performance</li>
                                <li>Prevent fraud and ensure data security</li>
                            </ul>
                        </div>

                        <div>
                            <h2 className="text-xl font-semibold text-slate-800 mb-3">4. Data Security</h2>
                            <p>We implement industry-standard security measures to protect your data, including 256-bit SSL encryption, secure cloud hosting, regular security audits, and role-based access controls. However, no method of transmission over the internet is 100% secure. We strongly advise you to safeguard your usernames and passwords, and avoid using the same passwords for different accounts. If you have any concerns about your personal information, please contact us at <a href="mailto:support@adeyaai.com" className="text-sky-600 hover:underline">support@adeyaai.com</a>, and we will respond within three business days.</p>
                        </div>

                        <div>
                            <h2 className="text-xl font-semibold text-slate-800 mb-3">5. Data Retention</h2>
                            <p>We retain your business data as long as your account is active. If you cancel your subscription, we will keep your data for 30 days after which it will be permanently deleted. You may request immediate deletion by contacting our support team.</p>
                        </div>

                        <div>
                            <h2 className="text-xl font-semibold text-slate-800 mb-3">6. Cookies and Tracking</h2>
                            <p>We use cookies to enhance your experience, remember your login session, and analyze platform usage. You can disable cookies in your browser settings, but some features may not function properly.</p>
                        </div>

                        <div>
                            <h2 className="text-xl font-semibold text-slate-800 mb-3">7. Third-Party Services</h2>
                            <p>We may use third-party services like payment gateways (Razorpay), email providers (SMTP), and cloud hosting (AWS, DigitalOcean). These services have their own privacy policies, and we encourage you to review them.</p>
                        </div>

                        <div>
                            <h2 className="text-xl font-semibold text-slate-800 mb-3">8. Your Rights</h2>
                            <p className="mb-2">You have the right to:</p>
                            <ul className="list-disc pl-6 space-y-1">
                                <li>Access and export your personal data</li>
                                <li>Correct inaccurate or incomplete data</li>
                                <li>Request deletion of your data</li>
                                <li>Withdraw consent for marketing communications</li>
                                <li>Lodge a complaint with data protection authorities</li>
                            </ul>
                        </div>

                        <div>
                            <h2 className="text-xl font-semibold text-slate-800 mb-3">9. Changes to This Privacy Policy</h2>
                            <p>Any modifications to the Privacy Policy will be posted on this page, and once posted, the new version will take effect. We will make an effort to notify you through the Services, by email, or by other means if we materially alter how we use or share personal information that we have already obtained from you through the Services.</p>
                        </div>

                        <div>
                            <h2 className="text-xl font-semibold text-slate-800 mb-3">10. Contact Information</h2>
                            <p>If you have any questions about this privacy policy or your data, please contact us at:</p>
                            <p className="mt-2">
                                <strong>Email:</strong> <a href="mailto:support@adeyaai.com" className="text-sky-600 hover:underline">support@adeyaai.com</a><br />
                                <strong>Phone:</strong> +91 98221 34536<br />
                                <strong>Address:</strong> UI MIDC Phase 4, Akola, Maharashtra 444001, India
                            </p>
                        </div>

                    </div>
                </div>
            </section>
            <Footer />
        </>
    );
}